import { MouseEventHandler } from 'react';

import { styled } from '@mui/material/styles';

import { RED } from 'constants/colors';

import CloseIcon from '@mui/icons-material/Close';

const PREFIX = 'RemoveButton';

const classes = {
  root: `${PREFIX}-root`
};

const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    alignSelf: 'baseline',
    position: 'absolute',
    alignItems: 'center',
    left: 0,
    width: '40px',
    height: '40px',
    transform: 'translate(-100%, 0)',
    borderRadius: '50% !important',
    color: RED,
    cursor: 'pointer'
  }
}));

const RemoveButton: React.FC<{
  onClick: MouseEventHandler<HTMLDivElement>;
}> = ({ onClick }) => {

  return (
    (<Root className={classes.root} onClick={onClick}>
      <CloseIcon />
    </Root>)
  );
};

export default RemoveButton;
